/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobListRequest {
    getFixupPrototypeFunction() { return BackgroundJobListRequest.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobListRequest>): BackgroundJobListRequest {
        let obj = Object.assign(new BackgroundJobListRequest(), model);
        BackgroundJobListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobListRequest>): BackgroundJobListRequest {
        if (!model) return null;
        return BackgroundJobListRequest.newInstance(<BackgroundJobListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobListRequest) {
        if (!obj) return;

        models.BackgroundJobListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobListRequest): boolean {
        Object.setPrototypeOf(obj, BackgroundJobListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.BackgroundJobFilter.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.BackgroundJobSortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.BackgroundJobSortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.BackgroundJobFilter;

}
